import { getUserConfiguration, isConsumer } from 'owa-session-store';
import { getOrigin } from 'owa-url/lib/getOrigin';
import getRootVdirName from 'owa-url/lib/getRootVdirName';

import store from '../store/store';

import type { AlternateAccount } from '../store/schema/AlternateAccount';

const SELECT_ACCOUNT_PARAM = 'prompt=select_account';

export function getCurrentUPN(): string | null {
    try {
        return getUserConfiguration()?.SessionSettings?.UserPrincipalName || '';
    } catch (e) {
        return null;
    }
}

// This is modeled after the way that the account switcher in SuiteUX works combined with what's in the default header.
export function generateAppSwitchUrl(account: AlternateAccount | null = null): string {
    const aadLoginDomain = isConsumer() ? 'https://outlook.office.com' : getOrigin();
    const rootVdirPath = getRootVdirName();
    if (account) {
        const domain = account.idp ? aadLoginDomain : 'https://outlook.live.com';
        return `${domain}/${rootVdirPath}/?login_hint=${encodeURIComponent(account.upn)}&book=${
            store.bookingMailbox
        }`;
    } else {
        return `${aadLoginDomain}/${rootVdirPath}/?${SELECT_ACCOUNT_PARAM}&book=${store.bookingMailbox}`;
    }
}
